import { render } from "./SignupView.vue?vue&type=template&id=9d294afe&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import "./SignupView.vue?vue&type=style&index=0&id=9d294afe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d294afe"]])

export default __exports__